import { StatusPill } from '../../../models/shared/status-pill';

export function spousalStatusPill(): StatusPill {
  return new StatusPill(0, $localize`Spousal`, '#024256', '#E6EEF1');
}
